import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

const oidcConfig = {
  authority: "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001",
  client_id: "IDT-IDT-DTC-IOT-004",

  redirect_uri: "https://ara.idtolu.net",
  post_logout_redirect_uri: "https://ara.idtolu.net",

  response_type: "code",
  response_mode: "query",
  scope: "openid profile email",

  automaticSilentRenew: false,
  loadUserInfo: true,
  //code_challenge_method: 'S256',

  // monitorSession: false, // Desactiva si hay problemas de CORS

  // Storage
  // userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Metadatos explícitos (CRÍTICO)
  metadata: {
    issuer: "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001",
    authorization_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/auth",
    token_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/token",
    userinfo_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/userinfo",
    end_session_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/logout",

    // FORZAR PKCE en metadata
    // code_challenge_methods_supported: ["S256"]
  },

  // Para debug en producción
  // extraHeaders: {
  //   'X-Forwarded-Proto': 'https'
  // },
  // Manejo de errores
  onSigninCallback: (user) => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
